import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

interface DeleteQuestionEventAdapterParams {
  source: 'personal_library' | 'shared_library';
  deleteType: 'single' | 'bulk';
  questionsCount: number;
}

type DeleteQuestionEventData = {
  source: 'personal_library' | 'shared_library';
  delete_type: 'single' | 'bulk';
  questions_count: number;
};

export class DeleteQuestionEventAdapter extends EventAdapter<DeleteQuestionEventData> {
  protected intercomEventKey = null;

  constructor({
    source,
    deleteType,
    questionsCount,
  }: DeleteQuestionEventAdapterParams) {
    super();

    this.eventData = {
      source,
      delete_type: deleteType,
      questions_count: questionsCount,
    };
  }
  protected amplitudeEventFunction = function sendDeleteQuestionEvent(
    event: DeleteQuestionEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.DeleteQuestion, event);
  };
}
